import { render, staticRenderFns } from "./AdxAndOpenBidding.vue?vue&type=template&id=52e15fad&"
import script from "./AdxAndOpenBidding.vue?vue&type=script&lang=js&"
export * from "./AdxAndOpenBidding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports